var Backbone = require('backbone')

var TabModel = require('./model')
var TabCollection = Backbone.Collection.extend({ model: TabModel })

module.exports = TabCollection



// WEBPACK FOOTER //
// ./js/behaviors/tabs/collection.js